<template>

	<div :class="{'special-characters':true}">

		<p>
			Have characters appearing as squares/rectangles (▯⌧) in your PDF report? <span @click="showModal = true">Click here</span>
		</p>

		<Modal v-if="showModal" @close="showModal = false">
			<template #content>
				<p>Characters that don't display correctly in your PDF report may be due to font limitations. To fix this, copy characters from this  <a href="https://fonts.google.com/noto/specimen/Noto+Sans+Math/glyphs" target="_blank">Google fonts page</a> (select from the left table, highlight on the right, then copy) and paste them into your text editor. These characters, should then appear correctly in your PDF.</p>
			</template>
		</Modal>

	</div>

</template>

<script>
import Modal from '../Display/Modal.vue'
export default {
	name: 'SpecialCharacters',
	components: {
		Modal
	},
	props: {},
	watch: {

		theDateFormat(newVal) {

			this.$emit('dateFormatUpdated', newVal);

		}
	},
	data() {

		return {
			showModal: false
		}

	},
	methods: {

		

	},
	created() {

		

	}

}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
p {
	margin: 0 0 10px;
	span, a {
		text-decoration: underline;
		cursor: pointer;
		color: inherit;
	}
}
</style>